import Layout from '@adv-mt/mt-layout-basic'

import LinkFactory from '../../../components/LinkFactory/index.js'

const Skeleton = () => (
  <Layout.Basic linkFactory={LinkFactory}>
    <div className="mt-UserTakeOut" />
  </Layout.Basic>
)

export default Skeleton
